import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FacilityUtilisationViewerComponent } from '../orders/utilisation/facility/facility-utilisation-viewer/facility-utilisation-viewer.component'
import { ElderBasicPaneLayoutComponent, ElderPaneComponent } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [FacilityUtilisationViewerComponent, ElderBasicPaneLayoutComponent, ElderPaneComponent],
})
export class DashboardComponent {
  constructor() {}
}
